(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-modal"]) return;
  try {
    

if (!customElements.get('migafas-cart-discount')) {
  customElements.define('migafas-cart-discount', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        event.stopPropagation();
        const input = this.querySelector('input');
        const code = input.value.trim();
        if (!code) { this.message('Enter a discount code.', true); input.focus(); return; }
        if (code.includes(',')) { this.message('Enter one discount code at a time.', true); return; }
        this.updateDiscount(code, false);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-remove-discount]');
        if (!button) return;
        event.preventDefault();
        this.updateDiscount(button.dataset.removeDiscount, true);
      });
    }
    message(text, error = false) {
      const status = this.querySelector('[data-discount-status]');
      status.textContent = text;
      status.style.color = error ? '#b42318' : '';
    }
    async updateDiscount(code, remove) {
      if (this.busy) return;
      this.busy = true;
      const modal = this.closest('cart-modal');
      const sectionId = this.dataset.sectionId;
      const root = window.Shopify.routes.root;
      const same = (a, b) => a.toLowerCase() === b.toLowerCase();
      this.querySelectorAll('button, input').forEach(el => el.disabled = true);
      this.setAttribute('aria-busy', 'true');
      this.message(remove ? 'Removing discount…' : 'Applying discount…');
      modal.showLoadingOverlay();
      let updated = false;
      try {
        const currentResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!currentResponse.ok) throw new Error('Could not read cart');
        const current = await currentResponse.json();
        const codes = Array.isArray(current.discount_codes)
          ? current.discount_codes.filter(item => item.applicable).map(item => item.code)
          : Array.from(this.querySelectorAll('[data-remove-discount]'), el => el.dataset.removeDiscount);
        const next = codes.filter(existing => !same(existing, code));
        if (!remove) next.push(code);
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: next.join(','), sections: [sectionId], sections_url: window.location.pathname })
        });
        if (!response.ok) throw new Error('Discount request failed');
        const cart = await response.json();
        updated = true;
        const html = cart.sections && cart.sections[sectionId];
        if (html) modal.updateFromSectionHtml(html); else await modal.reloadContent();
        const widget = modal.querySelector('migafas-cart-discount');
        if (!widget) return;
        const returnedCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        const match = returnedCodes.find(item => same(item.code, code));
        const applied = match ? match.applicable : Array.from(widget.querySelectorAll('[data-remove-discount]')).some(el => same(el.dataset.removeDiscount, code));
        if (remove) widget.message('Discount removed. Your subtotal has been updated.');
        else if (!applied) {
          widget.message('This code is invalid or does not apply to the items in your cart.', true);
          widget.querySelector('input').value = code;
        } else {
          const visibleCode = Array.from(widget.querySelectorAll('[data-remove-discount]')).some(el => same(el.dataset.removeDiscount, code));
          widget.message(visibleCode ? 'Discount applied. Your subtotal has been updated.' : 'Code applied. Any shipping discount is calculated at checkout.');
        }
        for (const entry of returnedCodes.filter(item => item.applicable)) {
          if (Array.from(widget.querySelectorAll('[data-remove-discount]')).some(el => same(el.dataset.removeDiscount, entry.code))) continue;
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.removeDiscount = entry.code;
          button.textContent = entry.code + ' ×';
          button.setAttribute('aria-label', 'Remove discount ' + entry.code);
          button.className = 'text-xs';
          button.style.cssText = 'border:1px solid currentColor;border-radius:4px;padding:5px 8px';
          widget.querySelector('[data-discount-codes]').appendChild(button);
        }
        widget.querySelector('[data-discount-status]').focus({preventScroll:true});
      } catch (error) {
        const widget = modal.querySelector('migafas-cart-discount') || this;
        widget.message(updated ? 'Your code may have been applied. Refresh the cart to confirm the latest subtotal.' : 'Could not verify the discount. Please try again.', true);
      } finally {
        modal.hideLoadingOverlay();
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('button, input').forEach(el => el.disabled = false);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyewear-guide"]) return;
  try {
    
(function(){
  function init(root){
    root.querySelectorAll('[data-guide-video]:not([data-ready])').forEach(function(container){
      container.dataset.ready='true';
      try{
        var url=new URL(container.dataset.guideVideo), host=url.hostname.toLowerCase(), id, src, player;
        if(url.protocol!=='https:') return;
        if(['youtube.com','www.youtube.com','m.youtube.com','youtu.be','www.youtube-nocookie.com','youtube-nocookie.com'].includes(host)){
          id=host==='youtu.be'?url.pathname.split('/')[1]:url.searchParams.get('v');
          if(!id && /^\/(embed|shorts|live)\//.test(url.pathname)) id=url.pathname.split('/')[2];
          if(!/^[a-zA-Z0-9_-]{11}$/.test(id||'')) return;
          src='https://www.youtube-nocookie.com/embed/'+id;
        } else if(['vimeo.com','www.vimeo.com','player.vimeo.com'].includes(host)){
          var parts=url.pathname.split('/').filter(Boolean);
          id=parts[0]==='video'?parts[1]:parts[0];
          if(!/^\d+$/.test(id||'')) return;
          src='https://player.vimeo.com/video/'+id;
          var hash=url.searchParams.get('h')||(parts[0]!=='video'?parts[1]:null);
          if(hash && /^[a-zA-Z0-9]+$/.test(hash)) src+='?h='+encodeURIComponent(hash);
        } else if(host==='cdn.shopify.com' && /\.mp4$/i.test(url.pathname)){
          player=document.createElement('video');player.controls=true;player.playsInline=true;player.preload='metadata';player.src=url.href;
          player.setAttribute('aria-label',container.dataset.videoTitle);
        }
        if(src){player=document.createElement('iframe');player.src=src;player.title=container.dataset.videoTitle+' — video';player.loading='lazy';player.allow='encrypted-media; picture-in-picture; fullscreen';player.allowFullscreen=true;player.referrerPolicy='strict-origin-when-cross-origin';}
        if(player){container.appendChild(player);container.hidden=false;}
      }catch(error){ /* An invalid URL must never interrupt the article. */ }
    });
  }
  init(document);
  document.addEventListener('DOMContentLoaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
  ['page:load','turbo:load','instant:load'].forEach(function(name){document.addEventListener(name,function(){init(document);});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    

if (!customElements.get('migafas-page-discount')) {
  customElements.define('migafas-page-discount', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const apply = event => {
        event.preventDefault();
        event.stopPropagation();
        const input = this.querySelector('input');
        const code = input.value.trim();
        if (!code) { this.message('Enter a discount code.', true); input.focus(); return; }
        if (code.includes(',')) { this.message('Enter one discount code at a time.', true); return; }
        this.updateDiscount(code, false);
      };
      this.querySelector('[data-apply-discount]').addEventListener('click', apply);
      this.querySelector('input').addEventListener('keydown', event => { if (event.key === 'Enter') apply(event); });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-remove-discount]');
        if (!button) return;
        event.preventDefault();
        this.updateDiscount(button.dataset.removeDiscount, true);
      });
    }
    message(text, error = false) {
      const status = this.querySelector('[data-discount-status]');
      status.textContent = text;
      status.style.color = error ? '#b42318' : '';
    }
    async updateDiscount(code, remove) {
      if (this.busy) return;
      this.busy = true;
      const section = document.getElementById('shopify-section-' + this.dataset.sectionId);
      const sectionId = this.dataset.sectionId;
      const root = window.Shopify.routes.root;
      const same = (a, b) => a.toLowerCase() === b.toLowerCase();
      this.querySelectorAll('button, input').forEach(el => el.disabled = true);
      this.setAttribute('aria-busy', 'true');
      this.message(remove ? 'Removing discount…' : 'Applying discount…');
      
      let updated = false;
      try {
        const currentResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!currentResponse.ok) throw new Error('Could not read cart');
        const current = await currentResponse.json();
        const codes = Array.isArray(current.discount_codes)
          ? current.discount_codes.filter(item => item.applicable).map(item => item.code)
          : Array.from(this.querySelectorAll('[data-remove-discount]'), el => el.dataset.removeDiscount);
        const next = codes.filter(existing => !same(existing, code));
        if (!remove) next.push(code);
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: next.join(','), sections: [sectionId], sections_url: window.location.pathname })
        });
        if (!response.ok) throw new Error('Discount request failed');
        const cart = await response.json();
        updated = true;
        const html = cart.sections && cart.sections[sectionId];
        if (!html) throw new Error('Cart section unavailable');
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.getElementById(section.id);
        if (!replacement) throw new Error('Cart section missing');
        section.innerHTML = replacement.innerHTML;
        const widget = section.querySelector('migafas-page-discount');
        if (!widget) return;
        const returnedCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        const match = returnedCodes.find(item => same(item.code, code));
        const applied = match ? match.applicable : Array.from(widget.querySelectorAll('[data-remove-discount]')).some(el => same(el.dataset.removeDiscount, code));
        if (remove) widget.message('Discount removed. Your subtotal has been updated.');
        else if (!applied) {
          widget.message('This code is invalid or does not apply to the items in your cart.', true);
          widget.querySelector('input').value = code;
        } else {
          const visibleCode = Array.from(widget.querySelectorAll('[data-remove-discount]')).some(el => same(el.dataset.removeDiscount, code));
          widget.message(visibleCode ? 'Discount applied. Your subtotal has been updated.' : 'Code applied. Any shipping discount is calculated at checkout.');
        }
        for (const entry of returnedCodes.filter(item => item.applicable)) {
          if (Array.from(widget.querySelectorAll('[data-remove-discount]')).some(el => same(el.dataset.removeDiscount, entry.code))) continue;
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.removeDiscount = entry.code;
          button.textContent = entry.code + ' ×';
          button.setAttribute('aria-label', 'Remove discount ' + entry.code);
          button.className = 'text-xs';
          button.style.cssText = 'border:1px solid currentColor;border-radius:4px;padding:5px 8px';
          widget.querySelector('[data-discount-codes]').appendChild(button);
        }
        widget.querySelector('[data-discount-status]').focus({preventScroll:true});
      } catch (error) {
        const widget = section.querySelector('migafas-page-discount') || this;
        widget.message(updated ? 'Your code may have been applied. Refresh the cart to confirm the latest subtotal.' : 'Could not verify the discount. Please try again.', true);
      } finally {
        
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('button, input').forEach(el => el.disabled = false);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
